<template>
    <div class="student-course">
        <div class="allBox app-body">
            <page-header @openLoginDiolog="goLogin" :state="isHaveLoginObj" @goExamintercept="judgeIslogin"/>
            <screening title="机构课程" ref="screening"
                       @select="onSelect"
                       style="margin-bottom: 30px"/>
            <section class="container">
                <el-tabs v-model="currentTab">
                    <el-tab-pane :name="tab.value" v-for="tab in TABS_LIST" :key="tab.value">
                        <span slot="label" class="font-size16">{{ tab.label }}</span>
                        <template v-if="courseMapList[currentTab].length">
                            <course-item v-for="item in courseMapList[currentTab]"
                                         :key="item.SourceId"
                                         @start-study="onStartStudy"
                                         :course="item"/>
                        </template>
                        <el-empty description="暂无课程" v-else/>
                        <pagination
                            :page-no.sync="paginationMap[currentTab].pageIndex"
                            :total="paginationMap[currentTab].total"
                            @change="getCourseList"
                            :p-size.sync="paginationMap[currentTab].pageSize"/>
                    </el-tab-pane>
                </el-tabs>
                <el-row type="flex" class="search-box">
                    <el-input placeholder="请输入关键字检索"
                              v-model="searchVal" size="medium">
                    </el-input>
                    <el-button size="medium"
                               icon="el-icon-search"
                               @click.stop="handleSearch"
                               style="margin-left: 10px"
                               type="primary">搜索
                    </el-button>
                </el-row>
            </section>
        </div>
        <bottomnav/>
    </div>
</template>

<script>
import PageHeader from "@/components/header";
import Screening from "@/components/screening"
import CourseItem from "@/views/course/cpns/CourseItem";
import pagination from "@/components/Pagination";
import { getCourseList } from "@/api/student-course"
import { TABS_LIST, getInitCourseList, getInitPagination, getInitSearchParams } from "./config"
import Bottomnav from "@/components/bottomnav";
import { addHotValue } from "@/api/user";

export default {
    name: "course",
    components: {
        Bottomnav,
        PageHeader,
        Screening,
        CourseItem,
        pagination
    },
    data() {
        return {
            isHaveLoginObj: "",
            currentTab: "later",
            searchVal: "",
            searchParamsMap: getInitSearchParams(),
            courseMapList: getInitCourseList(),
            paginationMap: getInitPagination(),
            TABS_LIST
        }
    },
    created() {
        this.initCourseList()
    },
    methods: {
        goLogin() {
            this.loginDiologShow = true
        },
        // 初始化课程列表
        initCourseList() {
            TABS_LIST.forEach(item => {
                this.getCourseList({
                    ...this.searchParamsMap[item.value],
                    ...this.paginationMap[item.value],
                    IsDisplayLimit: 1
                }, item.value)
            })
        },
        // 判断是否登录
        judgeIslogin() {
            let token = this.$store.state.user
            if (!token || token === "null") {
                this.goLogin()
            }
        },
        // 获取课程列表
        getCourseList(params, currentTab = this.currentTab) {
            params = params || {
                ...this.searchParamsMap[currentTab],
                ...this.paginationMap[currentTab],
                IsDisplayLimit: 1
            }
            getCourseList(params).then(res => {
                this.courseMapList[currentTab] = res.data
                this.paginationMap[currentTab].total = res.count
            })
        },
        onSelect(val) {
            this.ClassLevel = parseInt(val) === 1000 ? undefined : parseInt(val)
            this.searchParamsMap = getInitSearchParams({
                ClassLevel: this.ClassLevel
            })
            this.paginationMap = getInitPagination()
            this.searchVal = ""
            this.initCourseList()
        },
        // 处理搜索
        handleSearch() {
            this.searchParamsMap = getInitSearchParams({
                ClassLevel: this.ClassLevel,
                keyWord: this.searchVal
            })
            this.paginationMap = getInitPagination()
            this.initCourseList()
        },
        // 开始学习
        onStartStudy(course) {
            addHotValue(course.SourceId).then(res => {
                this.$router.push({
                    path: "/course-play",
                    query: {
                        SourceId: course.SourceId
                    }
                })
            })
        }
    }
}
</script>

<style scoped lang="less">
.container {
    background-color: #fff;
    box-sizing: border-box;
    min-height: 60vh;
    padding: 30px;
    position: relative;

    .search-box {
        position: absolute;
        top: 26px;
        right: 30px;
    }
}
</style>
